import { Component } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Avatar } from '@material-ui/core';
import TableContainer from '@mui/material/TableContainer';

import NoDataLabel from '../common/NoDataLabel';
import { formatCell } from './adStatsUtils';

const COLUMNS = [
  { key: 'organicViews', label: 'Organic Views', format: 'count' },
  { key: 'paidViews', label: 'Paid Views', format: 'count' },
  { key: 'totalViews', label: 'Total Views', format: 'count' },
  { key: 'organicSharePct', label: 'Organic %', format: 'percent' },
  { key: 'engagementRate', label: 'Eng. Rate', format: 'percent' },
  { key: 'paidCpv', label: 'Paid CPV', format: 'currency' },
  { key: 'paidCpm', label: 'Paid CPM', format: 'currency' },
];

class AdStatsCreatorTable extends Component {
  render() {
    const { rows } = this.props;

    if (!rows || rows.length === 0) {
      return <NoDataLabel offsetTop={10} />;
    }

    return (
      <TableContainer>
        <Table size="small" aria-label="organic versus paid by creator">
          <TableHead>
            <TableRow>
              <TableCell>Creator</TableCell>
              <TableCell align="right">Videos</TableCell>
              {COLUMNS.map((column) => (
                <TableCell key={column.key} align="right">
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.influencerId ?? row.name}>
                <TableCell component="th" scope="row">
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar
                      src={row.avatar || undefined}
                      style={{ width: 24, height: 24, marginRight: 8 }}
                    />
                    <span>{row.name}</span>
                  </div>
                </TableCell>
                <TableCell align="right">{formatCell(row.videoCount, 'count')}</TableCell>
                {COLUMNS.map((column) => (
                  <TableCell key={column.key} align="right">
                    {formatCell(row[column.key], column.format)}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
}

export default AdStatsCreatorTable;
